var routerIndex = {

  basicChildren: [
    {
      path: '/license/platform',
      name: 'platformManage',
      component: resolve => require(['@/views/license/platform/index'], resolve),
      meta: {
        title: '平台管理'
      }
    },
    {
      path: '/license/licenseType',
      name: 'licenseTypeManage',
      component: resolve => require(['@/views/license/licenseType/index'], resolve),
      meta: {
        title: '证照类型'
      }
    },
    {
      path: '/license/licenseManage',
      name: 'licenseManage',
      component: resolve => require(['@/views/license/licenseManage/manageIndex'], resolve),
      meta: {
        title: '证照管理'
      }
    },
    {
      path: '/license/licenseManage/useApply',
      name: 'useApply',
      component: resolve => require(['@/views/license/licenseManage/useApply/useapply'], resolve),
      meta: {
        title: '使用申请'
      }
    },
    {
      path: '/license/licenseManage/useApply/useApplyApproval/:type/:id',
      name: 'useApplyApproval',
      component: resolve => require(['@/views/license/licenseManage/useApply/useApplyApproval'], resolve),
      meta: {
        title: '证照使用审批'
      }
    },
    {
      path: '/license/licenseManage/useApply/useApplyApproval/:type/:id/:processKey/:taskKey',
      name: 'useApplyApproval',
      component: resolve => require(['@/views/license/licenseManage/useApply/useApplyApproval'], resolve),
      meta: {
        title: '证照使用审批'
      }
    },
    {
      path: '/license/licenseManage',
      name: 'addLicenseindex',
      component: resolve => require(['@/views/license/licenseManage/addLicenseindex'], resolve),
      meta: {
        title: '新建证照'
      }
    },
    {
      path: '/license/licenseManage',
      name: 'relevancePlatform',
      component: resolve => require(['@/views/license/licenseManage/relevancePlatformIndex'], resolve),
      meta: {
        title: '关联平台'
      }
    },
    // 		{
    // 			path: '/license/search',
    // 			name: 'licenseSearch',
    // 			component: resolve => require(['@/views/license/search/index'], resolve),
    // 			meta: {
    // 				title: '证照查询'
    // 			}
    // 		},
    {
      path: '/license/renewalRemind',
      name: 'renewalRemind',
      component: resolve => require(['@/views/license/renewalRemind/index'], resolve),
      meta: {
        title: '续期提醒'
      }
    },
    {
      path: '/expense/loanApplication',
      name: 'loanApplication',
      component: resolve => require(['@/views/expense/loanApplication/index'], resolve),
      meta: {
        title: '借款申请'
      }
    },
    {
      path: '/expense/loanApplication/loanApplicationApproval/:type/:id',
      name: 'loanApplicationApproval',
      component: resolve => require(['@/views/expense/loanApplication/loanApplicationApproval'], resolve),
      meta: {
        title: '借款申请审批'
      }
    },
    {
      path: '/expense/loanApplication/loanApplicationApproval/:type/:id/:processKey/:taskKey',
      name: 'loanApplicationApproval',
      component: resolve => require(['@/views/expense/loanApplication/loanApplicationApproval'], resolve),
      meta: {
        title: '借款申请审批'
      }
    },
    {
      path: '/expense/positionStandard',
      name: 'positionStandard',
      component: resolve => require(['@/views/expense/positionStandard/index'], resolve),
      meta: {
        title: '职位标准'
      }
    },
    {
      path: '/expense/regionalStandard',
      name: 'regionalStandard',
      component: resolve => require(['@/views/expense/regionalStandard/index'], resolve),
      meta: {
        title: '地区标准'
      }
    },
    {
      path: '/expense/defaultStandard',
      name: 'defaultStandard',
      component: resolve => require(['@/views/expense/defaultStandard/index'], resolve),
      meta: {
        title: '默认标准'
      }
    },
    {
      path: '/expense/travelApply',
      name: 'travelApply',
      component: resolve => require(['@/views/expense/travelApply/index'], resolve),
      meta: {
        title: '出差申请'
      }
    },
    {
      path: '/expense/travelApply/travelApplyApproval/:type/:id/:processKey/:taskKey',
      name: 'travelApplyApproval',
      component: resolve => require(['@/views/expense/travelApply/travelApplyApproval'], resolve),
      meta: {
        title: '出差申请审批'
      }
    },
    {
      path: '/expense/travelApply/travelApplyApproval/:type/:id',
      name: 'travelApplyApproval',
      component: resolve => require(['@/views/expense/travelApply/travelApplyApproval'], resolve),
      meta: {
        title: '出差申请审批'
      }
    },
    {
      path: '/expense/travelExpense',
      name: 'travelExpense',
      component: resolve => require(['@/views/expense/travelExpense/index'], resolve),
      meta: {
        title: '差旅报销'
      }
    },
    {
      path: '/expense/travelExpense/travelExpenseApproval/:type/:id',
      name: 'travelExpenseApproval',
      component: resolve => require(['@/views/expense/travelExpense/travelExpenseApproval'], resolve),
      meta: {
        title: '差旅报销审批'
      }
    },
    {
      path: '/expense/travelExpense/travelExpenseApproval/:type/:id/:processKey/:taskKey',
      name: 'travelExpenseApproval',
      component: resolve => require(['@/views/expense/travelExpense/travelExpenseApproval'], resolve),
      meta: {
        title: '差旅报销审批'
      }
    },
    {
      path: '/expense/CarExpense',
      name: 'CarExpense',
      component: resolve => require(['@/views/expense/CarExpense/index'], resolve),
      meta: {
        title: '用车报销'
      }
    },
    {
      path: '/expense/CarExpense/carExpenseApproval/:type/:id',
      name: 'carExpenseApproval',
      component: resolve => require(['@/views/expense/CarExpense/carExpenseApproval'], resolve),
      meta: {
        title: '用车报销审批'
      }
    },
    {
      path: '/expense/CarExpense/carExpenseApproval/:type/:id/:processKey/:taskKey',
      name: 'carExpenseApproval',
      component: resolve => require(['@/views/expense/CarExpense/carExpenseApproval'], resolve),
      meta: {
        title: '用车报销审批'
      }
    },
    {
      path: '/expense/travelAllowance',
      name: 'travelAllowance',
      component: resolve => require(['@/views/expense/travelAllowance/index'], resolve),
      meta: {
        title: '出差补助'
      }
    },
    {
      path: '/expense/paymentRequest',
      name: 'paymentRequest',
      component: resolve => require(['@/views/expense/paymentRequest/index'], resolve),
      meta: {
        title: '付款申请'
      }
    },
    {
      path: '/expense/paymentRequest/paymentRequestApproval/:type/:id',
      name: 'paymentRequestApproval',
      component: resolve => require(['@/views/expense/paymentRequest/paymentRequestApproval'], resolve),
      meta: {
        title: '付款申请审批'
      }
    },
    {
      path: '/expense/paymentRequest/paymentRequestApproval/:type/:id/:processKey/:taskKey',
      name: 'paymentRequestApproval',
      component: resolve => require(['@/views/expense/paymentRequest/paymentRequestApproval'], resolve),
      meta: {
        title: '付款申请审批'
      }
    },
    {
      path: '/expense/deliveryFee',
      name: 'deliveryFee',
      component: resolve => require(['@/views/expense/deliveryFee/index'], resolve),
      meta: {
        title: '快递费报销'
      }
    },
    {
      path: '/expense/deliveryFee/deliveryFeeApproval/:type/:id',
      name: 'deliveryFeeApproval',
      component: resolve => require(['@/views/expense/deliveryFee/deliveryFeeApproval'], resolve),
      meta: {
        title: '快递费报销审批'
      }
    },
    {
      path: '/expense/deliveryFee/deliveryFeeApproval/:type/:id/:processKey/:taskKey',
      name: 'deliveryFeeApproval',
      component: resolve => require(['@/views/expense/deliveryFee/deliveryFeeApproval'], resolve),
      meta: {
        title: '快递费报销审批'
      }
    },
    {
      path: '/expense/generalExpenses',
      name: 'generalExpenses',
      component: resolve => require(['@/views/expense/generalExpenses/index'], resolve),
      meta: {
        title: '通用报销'
      }
    },
    {
      path: '/expense/generalExpenses/generalExpenseApproval/:type/:id',
      name: 'generalExpenseApproval',
      component: resolve => require(['@/views/expense/generalExpenses/generalExpenseApproval'], resolve),
      meta: {
        title: '通用报销审批'
      }
    },
    {
      path: '/expense/generalExpenses/generalExpenseApproval/:type/:id/:processKey/:taskKey',
      name: 'generalExpenseApproval',
      component: resolve => require(['@/views/expense/generalExpenses/generalExpenseApproval'], resolve),
      meta: {
        title: '通用报销审批'
      }
    },
    {
      path: '/expense/fieldSignIn',
      name: 'fieldSignIn',
      component: resolve => require(['@/views/expense/fieldSignIn/index'], resolve),
      meta: {
        title: '外勤签到'
      }
    },
    {
      path: '/expense/print',
      name: 'print',
      component: resolve => require(['@/views/expense/print/index'], resolve),
      meta: {
        title: '打印'
      }
    },
    {
      path: '/chapter/chapterManager/chapterManagerIndex',
      name: 'chapterManagerIndex',
      component: resolve => require(['@/views/chapter/chapterManager/chapterManagerIndex'], resolve),
      meta: {
        title: '印章管理'
      }
    },
    {
      path: '/filing/filingIndex',
      name: 'filingIndex',
      component: resolve => require(['@/views/filing/filingIndex'], resolve),
      meta: {
        title: '报备管理'
      }
    },
    {
      path: '/biz/contract/contractApproval/:id/:processKey/:taskKey',
      name: 'bizContractApproval',
      component: resolve => require(['@/views/biz/contract/contractApproval'], resolve),
      meta: {title: '合同审批'}
    },
    {
      path: '/biz/contract/update/:id/:type/:check/:test',
      name: 'bizContractApproval',
      component: resolve => require(['@/views/biz/contract/update'], resolve),
      meta: {title: '合同详情'}
    },
    {
      path: '/biz/projectApproval/:id/:processKey/:taskKey',
      name: 'projectApproval',
      component: resolve => require(['@/views/biz/project/Approval/projectApproval'], resolve),
      meta: {title: '项目委派'}
    },
    {
      path: '/appVersion',
      name: 'appVersion',
      component: resolve => require(['@/views/system/appVersion/index'], resolve),
      meta: {title: 'app版本'}
    },
    {
      path: '/expense/fundApplication',
      name: 'fundApplication',
      component: resolve => require(['@/views/expense/fundApplication/fundApplicationIndex'], resolve),
      meta: {title: '资金申请'}
    },
    {
      path: '/expense/businessTrip/operate/:id/:type',
      name: 'businessTripOperate',
      component: resolve => require(['@/views/expense/fundApplication/businessTrip/operate'], resolve),
      meta: {title: '出差申请'}
    },
    {
      path: '/expense/businessTrip/businessTripApproval/:id/:processKey/:taskKey',
      name: 'businessTripApproval',
      component: resolve => require(['@/views/expense/fundApplication/businessTrip/businessTripApproval'], resolve),
      meta: {title: '出差申请审批'}
    },
    {
      path: '/expense/fundApplication/paymentRequest/operate/:id/:type',
      name: 'businessTripPaymentRequest',
      component: resolve => require(['@/views/expense/fundApplication/paymentRequest/operate'], resolve),
      meta: {title: '付款申请'}
    },
    {
      path: '/expense/fundApplication/paymentRequest/paymentRequestApproval/:id/:processKey/:taskKey',
      name: 'fundBusinessTripApproval',
      component: resolve => require(['@/views/expense/fundApplication/paymentRequest/paymentRequestApproval'], resolve),
      meta: {title: '付款申请审批'}
    },
    {
      path: '/expense/fundApplication/withdrow/operate/:id/:type',
      name: 'withdrowOperate',
      component: resolve => require(['@/views/expense/fundApplication/withdrow/operate'], resolve),
      meta: {title: '提现申请'}
    },
    {
      path: '/expense/fundApplication/withdrow/withdrowApproval/:id/:processKey/:taskKey',
      name: 'withdrowApproval',
      component: resolve => require(['@/views/expense/fundApplication/withdrow/withdrowApproval'], resolve),
      meta: {title: '提现申请审批'}
    },
    {
      path: '/expense/fundApplication/tenderFee/operate/:id',
      name: 'tenderFeeOperate',
      component: resolve => require(['@/views/expense/fundApplication/tenderFee/operate'], resolve),
      meta: {title: '招标费申请'}
    },
    {
      path: '/expense/fundApplication/tenderFee/tenderFeeApproval/:id',
      name: 'tenderFeeApproval',
      component: resolve => require(['@/views/expense/fundApplication/tenderFee/tenderFeeApproval'], resolve),
      meta: {title: '招标费审批'}
    },
    {
      path: '/expense/expenseReimbursement',
      name: 'expenseReimbursement',
      component: resolve => require(['@/views/expense/expenseReimbursement/index'], resolve),
      meta: {title: '费用报销'}
    },
    {
      path: '/expense/expenseReimbursement/travelExpense/operateIndex/:id/:type',
      name: 'operateIndex',
      component: resolve => require(['@/views/expense/expenseReimbursement/travelExpense/operateIndex'], resolve),
      meta: {
        title: '差旅报销详情'
      }
    },
    {
      path: '/expense/expenseReimbursement/travelExpense/travelExpenseApproval/:id/:processKey/:taskKey',
      name: 'travelExpenseApproval',
      component: resolve => require(['@/views/expense/expenseReimbursement/travelExpense/travelExpenseApproval'], resolve),
      meta: {
        title: '差旅报销审批'
      }
    },
    {
      path: '/expense/expenseReimbursement/hostExpense/operateIndex/:id/:type',
      name: 'hostExpenseOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/hostExpense/operateIndex'], resolve),
      meta: {title: '招待报销'}
    },
    {
      path: '/expense/expenseReimbursement/hostExpense/hostExpenseApproval/:id/:processKey/:taskKey',
      name: 'hostExpenseApproval',
      component: resolve => require(['@/views/expense/expenseReimbursement/hostExpense/hostExpenseApproval'], resolve),
      meta: {title: '招待报销审批'}
    },
    {
      path: '/expense/expenseReimbursement/marketCost/operateIndex/:id/:type',
      name: 'marketCostOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/marketCost/operateIndex'], resolve),
      meta: {title: '市场费报销'}
    },
    {
      path: '/expense/expenseReimbursement/marketCost/marketCostApproval/:id/:processKey/:taskKey',
      name: 'marketCostApproval',
      component: resolve => require(['@/views/expense/expenseReimbursement/marketCost/marketCostApproval'], resolve),
      meta: {title: '市场费报销审批'}
    },
    {
      path: '/expense/expenseReimbursement/otherCost/operate/:id/:type',
      name: 'otherCostOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/otherCost/operate'], resolve),
      meta: {title: '其他费用报销'}
    },
    {
      path: '/expense/expenseReimbursement/otherCost/otherCostApproval/:id/:processKey/:taskKey',
      name: 'otherCostOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/otherCost/otherCostApproval'], resolve),
      meta: {title: '其他费用报销审批'}
    },
    {
      path: '/expense/expenseReimbursement/tenderFeeExpense/operate/:id/:type',
      name: 'tenderFeeExpenseOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/tenderFeeExpense/operate'], resolve),
      meta: {title: '招标费报销'}
    },
    {
      path: '/expense/privateCarUtility',
      name: 'privateCarUtility',
      component: resolve => require(['@/views/expense/privateCarUtility/index'], resolve),
      meta: {title: '用车申请'}
    },
    {
      path: '/expense/privateCarUtility/operate/:type/:id',
      name: 'privateCarUtilityOperate',
      component: resolve => require(['@/views/expense/privateCarUtility/operate'], resolve),
      meta: {title: '用车申请详情'}
    },
    {
      path: '/expense/privateCarUtility/privateCarUtilityApproval/:id/:processKey/:taskKey',
      name: 'privateCarUtilityApproval',
      component: resolve => require(['@/views/expense/privateCarUtility/privateCarUtilityApproval'], resolve),
      meta: {title: '用车申请审批'}
    },
    {
      path: '/expense/hostApplication',
      name: 'hostApplication',
      component: resolve => require(['@/views/expense/hostApplication/index'], resolve),
      meta: {title: '招待申请'}
    },
    {
      path: '/expense/hostApplication/operate/:id/:type',
      name: 'hostApplicationOperate',
      component: resolve => require(['@/views/expense/hostApplication/operate'], resolve),
      meta: {title: '招待申请详情'}
    },
    {
      path: '/expense/hostApplication/hostApplicationApproval/:id/:processKey/:taskKey',
      name: 'hostApplicationApproval',
      component: resolve => require(['@/views/expense/hostApplication/hostApplicationApproval'], resolve),
      meta: {title: '招待申请审批'}
    },
    {
      path: '/expense/specialDuties',
      name: 'specialDuties',
      component: resolve => require(['@/views/expense/specialDuties/index'], resolve),
      meta: {title: '加班餐费'}
    },
    {
      path: '/expense/specialDuties/operate/:id/:type',
      name: 'specialDutiesOperate',
      component: resolve => require(['@/views/expense/specialDuties/operate'], resolve),
      meta: {title: '加班餐费申请详情'}
    },
    {
      path: '/expense/specialDuties/specialDutiesApproval/:id/:processKey/:taskKey',
      name: 'specialDutiesApproval',
      component: resolve => require(['@/views/expense/specialDuties/specialDutiesApproval'], resolve),
      meta: {title: '加班餐费审批'}
    },
    {
      path: '/expense/expenseReimbursement/driverCost/operateIndex/:id/:type',
      name: 'driverCostOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/driverCost/operateIndex'], resolve),
      meta: {title: '司机报销'}
    },
    {
      path: '/expense/expenseReimbursement/driverCost/driverCostApproval/:id/:processKey/:taskKey',
      name: 'driverCostApproval',
      component: resolve => require(['@/views/expense/expenseReimbursement/driverCost/driverCostApproval'], resolve),
      meta: {title: '司机报销审批'}
    },
    {
      path: '/expense/fundApplication/tenderFee/operate/:id/:type',
      name: 'tenderFeeOperate',
      component: resolve => require(['@/views/expense/fundApplication/tenderFee/operate'], resolve),
      meta: {title: '招标费申请详情'}
    },
    {
      path: 'expense/fundApplication/tenderFee/tenderFeeApproval/:id/:processKey/:taskKey',
      name: 'specialDutiesOperate',
      component: resolve => require(['@/views/expense/fundApplication/tenderFee/tenderFeeApproval'], resolve),
      meta: {title: '招标费申请审批'}
    },
    {
      path: '/expense/expenseReimbursement/tenderFeeExpense/tenderFeeExpenseApproval/:id/:processKey/:taskKey',
      name: 'tenderFeeExpenseApproval',
      component: resolve => require(['@/views/expense/expenseReimbursement/tenderFeeExpense/tenderFeeExpenseApproval'], resolve),
      meta: {title: '招标费报销审批'}
    },
    {
      path: '/expense/expenseReimbursement/privateCar/operate/:id/:type',
      name: 'privateCarOperate',
      component: resolve => require(['@/views/expense/expenseReimbursement/privateCar/operate'], resolve),
      meta: {title: '私车公用报销'}
    },
    {
      path: '/expense/expenseReimbursement/privateCar/privateCarApproval/:id/:processKey/:taskKey',
      name: 'privateCarApproval',
      component: resolve => require(['@/views/expense/expenseReimbursement/privateCar/privateCarApproval'], resolve),
      meta: {title: '私车公用报销审批'}
    },
    {
      path: '/employeeInfo/addressBook',
      name: 'addressBook',
      component: resolve => require(['@/views/employeeInfo/addressBook/index'], resolve),
      meta: {title: '通讯录'}
    },
    {
      path: '/employeeInfo/jobInfo',
      name: 'jobInfo',
      component: resolve => require(['@/views/employeeInfo/jobInfo/index'], resolve),
      meta: {title: '作业信息'}
    },
    {
      path: '/biz/archive',
      name: 'archiveLend',
      component: resolve => require(['@/views/biz/archive/archiveIndex'], resolve),
      meta: {title: '档案借阅'}
    },
    {
      path: '/oa/archive/manage',
      name: 'archiveManage',
      component: resolve => require(['@/views/biz/archive/manageIndex'], resolve),
      meta: {title: '档案管理'}
    },
    {
      path: '/resources/overtime',
      name: 'administrationOvertime',
      component: resolve => require(['@/views/resources/overtime/overtimeIndex'], resolve),
      meta: {title: '加班申请'}
    },
    {
      path: '/hr/attendance',
      name: 'attendance',
      component: resolve => require(['@/views/hr/attendanceLog/attendanceLogIndex'], resolve),
      meta: {title: '考勤管理'}
    },
    {
      path: '/hr/calendar',
      name: 'calendar',
      component: resolve => require(['@/views/hr/calendar/calendarIndex'], resolve),
      meta: {title: '节假日设置'}
    },
    {
      path: '/oa/help/question',
      name: 'question',
      component: resolve => require(['@/views/help/question/questionIndex'], resolve),
      meta: { title: '常见问题' }
    },
    {
      path: '/oa/help/question/:type/:id',
      name: 'questionView',
      component: resolve => require(['@/views/help/question/questionOperate'], resolve),
      meta: { title: '常见问题详情' }
    },
    {
      path: '/oa/help/knowledge',
      name: 'knowledge',
      component: resolve => require(['@/views/help/knowledge/knowledgeIndex'], resolve),
      meta: { title: '知识库' }
    },
    {
      path: '/oa/help/knowledge/:type/:id',
      name: 'knowledgeView',
      component: resolve => require(['@/views/help/knowledge/knowledgeOperate'], resolve),
      meta: { title: '知识库详情' }
    },
    {
      path: '/oa/help/download',
      name: 'download',
      component: resolve => require(['@/views/help/download/downloadIndex'], resolve),
      meta: { title: '常用资料' }
    },
    {
      path: '/oa/help/download/:type/:id',
      name: 'downloadView',
      component: resolve => require(['@/views/help/download/downloadOperate'], resolve),
      meta: { title: '常用资料详情' }
    },
    {
      path: '/basic/checkList',
      name: 'checkList',
      component: resolve => require(['@/views/biz/business/checkList'], resolve),
      meta: { title: '核对表管理' }
    },
    {
      path: '/oa/hr/document',
      name: 'documentList',
      component: resolve => require(['@/views/hr/document/documentIndex'], resolve),
      meta: { title: '公文管理' }
    },
    {
      path: '/oa/hr/document/:type/:id/:processKey/:taskId',
      name: 'privateCarApproval',
      component: resolve => require(['@/views/hr/document/documentOperate'], resolve),
      meta: {title: '公文管理详情'}
    },
    {
      path: '/biz/workTime',
      name: 'workTimeIndex',
      component: resolve => require(['@/views/hr/workTime/workTimeIndex'], resolve),
      meta: {title: '工时管理'}
    },
    {
      path: '/biz/workTime/:type/:id/:processKey/:taskKey',
      name: 'workTimeOperate',
      component: resolve => require(['@/views/hr/workTime/workTimeOperate'], resolve),
      meta: { title: '工时填报' }
    },
    {
      path: '/biz/workTimeApproval/:type/:id/:processKey/:taskKey',
      name: 'workTimeApproval',
      component: resolve => require(['@/views/hr/workTime/workTimeApproval'], resolve),
      meta: { title: '工时审阅' }
    },
  ]
}

export default routerIndex



// WEBPACK FOOTER //
// ./src/router/routerIndex.js